import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToTop } from 'shared/utils/common';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const desktopContainerEle = document.getElementById('scrollableTarget');

    if (
      desktopContainerEle &&
      window.matchMedia('(min-width: 768px)').matches
    ) {
      desktopContainerEle.scroll({ top: 0 });
    }

    scrollToTop();
  }, [pathname]);

  return null;
}
